import { render, staticRenderFns } from "./GRMD.vue?vue&type=template&id=0c61374b"
import script from "./GRMD.vue?vue&type=script&lang=js"
export * from "./GRMD.vue?vue&type=script&lang=js"
import style0 from "./GRMD.vue?vue&type=style&index=0&id=0c61374b&prod&lang=css"
import style1 from "./GRMD.vue?vue&type=style&index=1&id=0c61374b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports